import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import './Responsive.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store/app';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import axios from 'axios';
import { attachDecryptInterceptor } from './utils/responseCrypto';
let persistor = persistStore(store);

// Covers the services that call the default axios instance directly
// instead of going through axiosClient.
attachDecryptInterceptor(axios);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* <SocketContext.Provider value={client}> */}
          <App />
        {/* </SocketContext.Provider> */}
      </PersistGate>
    </Provider>
);

reportWebVitals();
